import React from "react"
import Container, { type ContainerProps } from "./Container"
import { twMerge } from "tailwind-merge"

// we can expand this as needed, but for now the prop interface is the same so lets keep
// it as an empty extension
export interface ColumnContainerProps extends ContainerProps {}

const defaultStyles = "flex-col space-y-5"

/**
 * ColumnContainer component.
 *
 * This component renders a Container component with column-oriented styles.
 *
 * @component
 * @param {ColumnContainerProps} props The properties for the component.
 * @returns {React.ReactNode} The rendered container element.
 */
const ColumnContainer = React.forwardRef<HTMLDivElement, ColumnContainerProps>(
  function Column({ children, styleOverrides, ...props }, ref) {
    const className = twMerge(defaultStyles, styleOverrides)

    return (
      <Container ref={ref} styleOverrides={className} {...props}>
        {children}
      </Container>
    )
  },
)

ColumnContainer.displayName = "ColumnContainer"

export default ColumnContainer
